module.exports = __webpack_public_path__ + "8a4ef1e9ab650fc185a0fa5608ba53b8.jpg";